import { savedOrderDetailsTotalStyles as styles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsTotal";
import { css } from "styled-components";

styles.cartTotal = {
    ...styles.cartTotal,
    labelGridItem: {
        ...styles.cartTotal?.labelGridItem,
        css: css`
            font-size: 18px;
        `,
    },
    valueGridItem: {
        ...styles.cartTotal?.valueGridItem,
        css: css`
            font-size: 18px;
        `,
    },
};
